import { useMutation, useQueryClient } from "@tanstack/react-query";

import { migratePseudoCropExplorationsToUser } from "services";

import { GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES, MIGRATE_PSEUDO_CROP_EXPLORATIONS_TO_USER } from "consts";

export const useMigratePseudoCropExplorationsToUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [MIGRATE_PSEUDO_CROP_EXPLORATIONS_TO_USER],
    mutationFn: migratePseudoCropExplorationsToUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
